<app-relatorio-container
    tituloRelatorio="Requerimento de Renovação"
    descricaoRelatorio="Requerimento de renovação de certificado de inscrição PJ."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'requerimento-renovacao-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <div class="field">
                <label for="dataAlteracao" class="font-semibold block mb-2">Data da última alteração</label>
                <p-datepicker inputId="dataAlteracao" formControlName="dataAlteracao" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" placeholder="dd/mm/aaaa"></p-datepicker>
            </div>

            <div class="field">
                <label class="font-semibold block mb-2">Corpo clínico</label>
                <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-2">
                        <p-radiobutton inputId="ccSemAlteracao" formControlName="corpoClinicoAlterado" [value]="false"></p-radiobutton>
                        <label for="ccSemAlteracao">Sem alterações desde a última manutenção</label>
                    </div>
                    <div class="flex items-center gap-2">
                        <p-radiobutton inputId="ccAlterado" formControlName="corpoClinicoAlterado" [value]="true"></p-radiobutton>
                        <label for="ccAlterado">Alterado (alteração em anexo)</label>
                    </div>
                </div>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Requerimento" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
